import Graphic from 'components/graphic';
import { Logo } from 'components/logo/logo-component';
import NewsletterHome from 'components/newsletter/newsletter-home';
import NewsletterModal from 'components/newsletter/newsletter-modal';
import { createPost } from 'components/post/post-helpers';
import { PostType } from 'components/post/post-types';
import { getPostsByTag } from 'lib/db/post';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { NextSeo } from 'next-seo';
import { useEffect, useState } from 'react';

const Subscribe = ({
  homepageGraphicPosts,
}: {
  homepageGraphicPosts: PostType[];
}) => {
  const [modalId, setModalId] = useState<number | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    let errorTimeout: NodeJS.Timeout;
    if (error) {
      errorTimeout = setTimeout(() => {
        setError('');
      }, 2000);
    }

    return () => {
      clearTimeout(errorTimeout);
    };
  }, [error]);

  const pageURL = `${process.env.NEXT_PUBLIC_SITE_URL}/subscribe`;

  return (
    <div className="mx-auto px-4 md:container sm:w-full md:px-5">
      <NextSeo
        canonical={pageURL}
        title="A weekly dose of insights to grow your SaaS."
        description="Get the 5-minute newsletter and save 100+ hours of research per report."
        openGraph={{
          url: pageURL,
          title: 'A weekly dose of insights to grow your SaaS.',
          description:
            'Get the 5-minute newsletter and save 100+ hours of research per report.',
        }}
      />
      <div className="py-10 pt-8">
        <Link href={'/'}>
          <Logo />
        </Link>
      </div>
      <div className="mx-auto px-4 md:container sm:w-full md:px-5">
        <div className="mb-12">
          <div className=" flex flex-row items-baseline">
            <div className="lg:w-2/3">
              <NewsletterHome handleCloseModal={() => {}} />
            </div>
            <div className="hidden w-full items-center justify-end md:block lg:col-span-2">
              <Graphic posts={homepageGraphicPosts} />
            </div>
          </div>
        </div>
      </div>
      {modalId && (
        <NewsletterModal open={!!modalId} onClose={() => setModalId(null)} />
      )}
    </div>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const homepageGraphicPosts = await getPostsByTag({
    tag: 'homepage-graphic',
    limit: 5,
  });
  return {
    props: {
      homepageGraphicPosts: homepageGraphicPosts.map(createPost),
    },
    revalidate: 600,
  };
};

export default Subscribe;
